// src/hooks/useDashboard.js
import { useState, useCallback } from 'react';
import { fetchComponents } from '../services/api';

export function useDashboard() {
  const [image, setImage] = useState(null);
  const [components, setComponents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [diagramContrast, setDiagramContrast] = useState('normal');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const [fileHistory, setFileHistory] = useState([]);
  const [autoZoom, setAutoZoom] = useState(true);

  const loadComponents = useCallback(() => {
    setLoading(true);
    fetchComponents().then((data) => {
      setComponents(data);
      setLoading(false);
    });
  }, []);

  const handleUpload = useCallback((file) => {
    const url = URL.createObjectURL(file);
    const entry = { name: file.name, url, size: file.size, uploadedAt: new Date() };
    setImage(entry);
    setFileHistory((prev) => [entry, ...prev.slice(0, 4)]);
    setZoom(1);
    setPan({ x: 0, y: 0 });
    setSelectedId(null);
    loadComponents();
  }, [loadComponents]);

  const handleSelectComponent = useCallback((id) => {
    setSelectedId((prev) => (prev === id ? null : id));
  }, []);

  const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z + 0.25, 4)), []);
  const handleZoomOut = useCallback(() => setZoom((z) => Math.max(z - 0.25, 0.25)), []);
  const handleReset = useCallback(() => { setZoom(1); setPan({ x: 0, y: 0 }); }, []);

  const filteredComponents = components.filter((c) => {
    const q = searchQuery.toLowerCase();
    const matchesSearch = !q ||
      c.name.toLowerCase().includes(q) ||
      c.ref.toLowerCase().includes(q) ||
      c.value.toLowerCase().includes(q);
    const matchesCategory = activeCategory === 'All' || c.category === activeCategory;
    return matchesSearch && matchesCategory;
  });

  return {
    image, handleUpload,
    components, filteredComponents, loading,
    selectedId, handleSelectComponent,
    zoom, setZoom, pan, setPan, handleZoomIn, handleZoomOut, handleReset,
    sidebarOpen, setSidebarOpen,
    diagramContrast, setDiagramContrast,
    searchQuery, setSearchQuery,
    activeCategory, setActiveCategory,
    fileHistory,
    autoZoom, setAutoZoom,
  };
}
